<script>
    import { ethers } from 'ethers'
    import ITierArtifact from '../../abi/iTier.json'
    import { tierReport } from '../../utils'
    import { signer } from 'svelte-ethers-store'
    import { ELIGIBILITY_STATUSES } from '../../constants/constants';

    export let tierData,
        minimumStatus,
        againstBlock,
        eligibleStatus

    const checkEligibility = async ( tier) => {
        const report = await tier.report($signer.getAddress())
        const parsedReport = tierReport(report);
        const hasTier = parsedReport[Number(minimumStatus)-1] < againstBlock
        if (!hasTier) return (eligibleStatus = ELIGIBILITY_STATUSES.INELIGIBLE)
        eligibleStatus = ELIGIBILITY_STATUSES.ELIGIBLE
    }

    $: if (minimumStatus !== undefined && tierData?.id) {
        if(minimumStatus === '0')
            eligibleStatus = ELIGIBILITY_STATUSES.ELIGIBLE
        else{
            const tier = new ethers.Contract(tierData.id, ITierArtifact.abi, $signer)
            checkEligibility(tier)
        }
    }
</script>

{#if minimumStatus !== '0'}
    {#if eligibleStatus === ELIGIBILITY_STATUSES.ELIGIBLE}
        <section class="gradient-border">
            ✅ You are eligible for this Sale.
        </section>
    {:else if eligibleStatus === ELIGIBILITY_STATUSES.INELIGIBLE}
        <section class="gradient-border">
            ❌ You are not eligible for this sale as you are not part of this tier.
        </section>
    {/if}
{:else}
    <section class="gradient-border">This Sale is open for everyone.</section>
{/if}